<template>
  <div>
    <FormControl :label="label" :required="required" :disabled="disabled">
      <div>
        <input
          ref="input"
          @keyup="onDaysKeyup($event)"
          type="number"
          v-model="model[name]"
          class="form-control"
          :placeholder="label"
          :disabled="disabled"
        />
      </div>
      <!--      <div class="mt-1" v-if="isBusinessDaysOnly()">-->
      <!--        <small>{{ business_days.length }} {{ i18n.app.days.business_days.toLowerCase() }}</small>-->
      <!--      </div>-->
      <div v-if="holidays">
        <div class="mt-1" v-if="holidays.length">
          <b>{{ i18n.app.holidays.label }}:</b>
        </div>
        <div v-for="holiday in holidays" :key="holiday.value">{{ holiday.label }}</div>
      </div>
    </FormControl>
    <FormControl :label="i18n.app.days.business_days" :disabled="disabled">
      <div>
        <input
          ref="input"
          @keyup="onBusinessDaysKeyup($event)"
          type="number"
          v-model="num_of_business_days"
          class="form-control"
          :placeholder="i18n.app.days.business_days"
          :disabled="disabled"
        />
      </div>
    </FormControl>
  </div>
</template>

<script>
import FormControl from "./FormControl";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const KEY_CODE_BLACKLIST = ['Tab', 'Space', 'Shift', 'Meta', 'Control', 'Alt', 'ArrowLeft', 'ArrowRight'];

const Mode = {
  DEFAULT: 'DEFAULT',
  BUSINESS_DAYS: 'BUSINESS_DAYS',
}

export default {
  name: "date-difference-input",
  props: [
    "required",
    "label",
    "model",
    "name",
    "start",
    "end",
    "disabled",
    "round",
    "round_up_after",
    "is_business_days_only",
    'country_id'
  ],
  components: {
    FormControl
  },
  data() {
    return {
      holidays: [],
      weekend_days: [],
      business_days: [],
      num_of_business_days: 0
    };
  },
  mounted() {

    if (this.model && this.model.id) {
      this.recalcDifference();
    }

    if (!this.model[this.end]) {
      this.onChange(this.getValue());
    }
  },
  methods: {
    getValue() {
      return this.model[this.name];
    },
    setValue(val) {
      this.model[this.name] = val;
      this.$forceUpdate();
    },
    isValidKey(key) {
      return KEY_CODE_BLACKLIST.indexOf(key) == -1;
    },
    onDaysKeyup($event) {
      if (!this.isValidKey($event.key)) return;

      this.onChange($event.target.value);
    },
    onBusinessDaysKeyup($event) {

      if (!this.isValidKey($event.key)) return;

      this.onChange($event.target.value, true);
    },
    onChange(days, isBusinessDayChange = false) {
      const start = this.model[this.start];

      if (!days) return;
      if (!start) return;

      this.recalcDifference(days, isBusinessDayChange);
    },
    onBusinessDaysChange(days) {
      if (!days) return;

      this.onChange(days, true);
    },
    isBusinessDaysOnly() {
      return this.is_business_days_only || this.is_business_days_only == null;
    },
    async recalcDifference(numOfDays = null, isBusinessDayChange = false) {

      this.holidays = [];
      this.weekend_days = [];
      this.business_days = [];

      const start = this.model[this.start];
      const end = this.model[this.end];

      if (start && (end || numOfDays)) {

        const data = await axios
          .post(`${env.API_URL}/date/difference`, {
            start: start,
            end: !numOfDays ? end : null,
            num_of_days: numOfDays,
            country_id: this.countryId(),
            mode: isBusinessDayChange ? Mode.BUSINESS_DAYS : Mode.DEFAULT
          })
          .then(resp => {
            return resp.data;
          }
        );

        this.setValue(data.diff_in_days);
        this.num_of_business_days = data.diff_in_business_days;
        this.holidays = data.holidays;
        this.weekend_days = data.weekend_days;
        this.business_days = data.business_days;

        if (numOfDays) {
          const time = this.getValue() * 24 * 60 * 60 * 1000;
          const startDate = new Date(start);
          const endDate = dayjs(startDate.getTime() + time).local().format().substring(0, '0000-00-00T00:00'.length);

          this.$emit("change", endDate);
        }
      }
    },
    countryId() {
      return this.$store?.state?.user?.preference?.country_id ?? this.country_id;
    }
  },
};
</script>
